module.exports = __webpack_public_path__ + "static/img/reject.92feb844.png";